import React from 'react'
import { Switch, withRouter } from 'react-router-dom'

import RouteNotFound from '../../../../RouteNotFound'
import PrivateRoute from '../../../../../common-components/routes/PrivateRoute'

import PrelimInfoVerification from '../../../../PrelimInfoVerification'

import Dashboard from './WarehouseDashboard'
import ManageUsers from '../../../../ManageUsers'
import ManageContactsAndSubscriptions from '../../../../ManageContactsAndSubscriptions'
import ManageAddresses from '../../../../ManageAddresses'

import {
  URL_PATHS,
} from '../../../../../constants'

import { createRelativePath } from '../../../../../utils'
import AcknowledgeInboundShipments from '../../../../AcknowledgeInboundShipments'
import ReportInventory from '../../../../ReportInventory/ReportInventory'


// CODE_COMMENTS_26
const getRoutesList = ({
  match,
  customerId,
  hasAcknowledgeShipmentsPermissions,
  hasManageUsersAndContactsPermissions,
  hasAddressesPermissions,
  hasReportInventoryPermissions,
}) => ([
  <PrivateRoute
    exact
    key={URL_PATHS.root.path}
    path={createRelativePath(match, URL_PATHS.root.path)}
    render={
      routeProps => (
        <PrelimInfoVerification
          componentToRenderIfVerified={Dashboard}
          customerId={customerId}
          {...routeProps}
        />
      )
    }
  />,
  ...(
    hasAcknowledgeShipmentsPermissions
      ? [
        <PrivateRoute
          exact
          key={URL_PATHS.acknowledgeInboundShipments.path}
          path={createRelativePath(match, URL_PATHS.acknowledgeInboundShipments.path)}
          render={
            routeProps => (
              <PrelimInfoVerification
                componentToRenderIfVerified={AcknowledgeInboundShipments}
                customerId={customerId}
                {...routeProps}
              />
            )
          }
        />,
      ]
      : []
  ),
  ...(
    hasReportInventoryPermissions
      ? [
        <PrivateRoute
          exact
          key={URL_PATHS.reportEmptyKegs.path}
          path={createRelativePath(match, URL_PATHS.reportEmptyKegs.path)}
          render={
            routeProps => (
              <PrelimInfoVerification
                componentToRenderIfVerified={ReportInventory}
                customerId={customerId}
                {...routeProps}
              />
            )
          }
        />,
      ]
      : []
  ),
  ...(
    hasManageUsersAndContactsPermissions
      ? [
        <PrivateRoute
          exact
          key={URL_PATHS.users.path}
          path={createRelativePath(match, URL_PATHS.users.path)}
          render={
            routeProps => (
              <PrelimInfoVerification
                componentToRenderIfVerified={ManageUsers}
                customerId={customerId}
                {...routeProps}
              />
            )
          }
        />,
        <PrivateRoute
          exact
          key={URL_PATHS.contacts.path}
          path={createRelativePath(match, URL_PATHS.contacts.path)}
          render={
            routeProps => (
              <PrelimInfoVerification
                componentToRenderIfVerified={ManageContactsAndSubscriptions}
                customerId={customerId}
                {...routeProps}
              />
            )
          }
        />,
      ]
      : []
  ),
  ...(
    hasAddressesPermissions
      ? [
        <PrivateRoute
          exact
          key={URL_PATHS.addresses.path}
          path={createRelativePath(match, URL_PATHS.addresses.path)}
          render={
            routeProps => (
              <PrelimInfoVerification
                componentToRenderIfVerified={ManageAddresses}
                customerId={customerId}
                {...routeProps}
              />
            )
          }
        />,
      ]
      : []
  ),
])

export default withRouter(props => (
  <Switch>
    {getRoutesList(props)}
    <RouteNotFound />
  </Switch>
))
